import { render, staticRenderFns } from "./Filtro.vue?vue&type=template&id=465be964&scoped=true&lang=pug&"
import script from "./Filtro.vue?vue&type=script&lang=js&"
export * from "./Filtro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465be964",
  null
  
)

export default component.exports